import React from "react";
import styles from "./index.module.css";
import {Button, Flex, Table, TableBody, TableCell, TableRow, Text, useTheme} from "@aws-amplify/ui-react";
import {AiOutlineClose} from "react-icons/ai";
import {useNavigate} from "react-router-dom";
import {FiLogOut, FiUser} from "react-icons/fi";
import {RiLockPasswordLine} from "react-icons/ri";
import Drawer from "react-modern-drawer";

const UserMenu = (
  {
    userMenuOpen = false,
    setUserMenuOpen,
    logOut
  }
) => {
  const {tokens} = useTheme();
  const navigate = useNavigate();

  return (
    <Drawer
      size={300}
      duration={300}
      direction='right'
      open={userMenuOpen}
      className={styles.userMenu}
      onClose={() => setUserMenuOpen(false)}
    >
      <Flex
        gap="0"
        width="100%"
        height="100%"
        direction="column"
        justifyContent="flex-start"
        textAlign="right"
      >
        <Flex
          height="90px"
          width="100%"
          direction="row"
          padding={tokens.space.large}
          className={styles.userMenuCloseWrapper}
        >
          <Button
            className={styles.iconButton}
            onClick={() => setUserMenuOpen(false)}
          >
            <AiOutlineClose/>
          </Button>
        </Flex>

        <Table className={styles.userMenuTable}>
          <TableBody>
            <TableRow>
              <TableCell
                onClick={() => {
                  navigate("/utente")
                  setUserMenuOpen(false)
                }}
                className={styles.userMenuTableCell}
              >
                <Text className={styles.userMenuTableCellText}>
                  <Button
                    color="#000"
                    className={styles.iconButton}
                  >
                    <FiUser/>
                  </Button>
                  {' '}
                  Profilo
                </Text>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                onClick={() => {
                  navigate("/utente/cambia-password")
                  setUserMenuOpen(false)
                }}
                className={styles.userMenuTableCell}
              >
                <Text className={styles.userMenuTableCellText}>
                  <Button
                    color="#000"
                    className={styles.iconButton}
                  >
                    <RiLockPasswordLine/>
                  </Button>
                  {' '}
                  Cambia password
                </Text>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                onClick={() => {
                  logOut()
                  setUserMenuOpen(false)
                }}
                className={styles.userMenuTableCell}
              >
                <Text className={styles.userMenuTableCellText}>
                  <Button
                    color="#000"
                    className={styles.iconButton}
                  >
                    <FiLogOut/>
                  </Button>
                  {' '}
                  Logout
                </Text>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Flex>
    </Drawer>
  );
}

export default UserMenu;